import React from 'react'

function IncidentIcon() {
  return (
   <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 20V11.2111M9.00003 15.8919H6.50006C5.67164 15.8919 5.00008 16.5816 5.00008 17.4324V18.973C5.00008 19.5402 5.44779 20 6.00007 20H15C16.1046 20 17 19.0804 17 17.9459V16.2481C17.0055 13.8802 15.4318 11.8163 13.1922 11.254C10.4347 10.591 7.56534 10.591 4.80784 11.254C2.56819 11.8163 0.994506 13.8802 1.00001 16.2481L1.00012 18.973M9.00003 10.7568V20M12.3125 4.40203C12.3125 6.28091 10.8295 7.80405 9.00004 7.80405C7.17062 7.80405 5.68758 6.28091 5.68758 4.40203C5.68758 2.52314 7.17062 1 9.00004 1C10.8295 1 12.3125 2.52314 12.3125 4.40203Z" stroke="#0623C1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
}

export default IncidentIcon